import { render, staticRenderFns } from "./DrawerNav.vue?vue&type=template&id=2b6a6efc&scoped=true&"
import script from "./DrawerNav.vue?vue&type=script&lang=js&"
export * from "./DrawerNav.vue?vue&type=script&lang=js&"
import style0 from "./DrawerNav.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DrawerNav.vue?vue&type=style&index=1&id=2b6a6efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a6efc",
  null
  
)

export default component.exports